import Clickable from 'components/Common/Clickable'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import ModalContext from 'contexts/ModalContext'
import { rem } from 'polished'
import React, { useCallback, useContext } from 'react'
import styled from 'styled-components'
import ExperienceGiveAsGiftInfoModal from './ExperienceGiveAsGiftInfoModal'
import useTrackExperienceOfferEvent from 'contexts/support/useTrackExperienceOfferEvent'

const IconText = styled(Clickable)`
  display: flex;
  align-items: center;

  > * + * {
    margin-left: ${rem(8)};
  }
`

interface Props {
  experience: App.ExperienceOffer
  onSupportEmailClick?: () => void
  onSupportNumberClick?: () => void
}

function ExperienceGiveAsGiftInfoText(props: Props) {
  const { experience, onSupportEmailClick, onSupportNumberClick } = props
  const showModal = useContext(ModalContext)
  const trackEvent = useTrackExperienceOfferEvent()

  const handleClick = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    e.preventDefault()
    showModal(<ExperienceGiveAsGiftInfoModal
      experience={experience}
      onSupportEmailClick={onSupportEmailClick}
      onSupportNumberClick={onSupportNumberClick}
    />)
    trackEvent('GIFTING_AVAILABLE_CLICKED')
  }, [experience, showModal, trackEvent, onSupportEmailClick, onSupportNumberClick])

  return (
    <IconText onClick={handleClick}>
      <BodyText colour="highlight-secondary" variant="medium" weight="bold">
        Gifting available
      </BodyText>
      <LineInfoCircleIcon colour="neutral-one" size="S" />
    </IconText>
  )
}

export default ExperienceGiveAsGiftInfoText
